var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticStyle:{"margin-right":"5px","white-space":"nowrap"},attrs:{"for":"text"}},[_vm._v(" "+_vm._s(_vm.data.label)+" ")]),_c('div',[(_vm.isActive || _vm.isDataTableField)?_c('span',{staticClass:"setting-icon"},[_c('i',{staticClass:"el-icon-s-tools",on:{"click":_vm.openSettings}})]):_vm._e()]),_c('div',{ref:"table",staticClass:"resizable-table",style:({
      display: 'grid',
      gridTemplateColumns: _vm.columnStyles,
      gridTemplateRows: _vm.rowStyles,
      gridGap: `${_vm.cellSpacing}px`,
      border: `${_vm.borderSize}px solid black`,
    })},_vm._l((_vm.tableCells),function(cell,index){return _c('div',{key:index,style:({
        border: `${_vm.borderSize}px solid black`,
        padding: `${_vm.cellPadding}px`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
      })},[((index + 1) % _vm.columns !== 0)?_c('div',{staticClass:"resize-handle-col",on:{"mousedown":function($event){_vm.startResize($event, (index % _vm.columns))}}}):_vm._e(),(index < (_vm.rows - 1) * _vm.columns || index >= (_vm.rows - 1) * _vm.columns)?_c('div',{staticClass:"resize-handle-row",on:{"mousedown":function($event){_vm.startRowResize($event, Math.floor(index / _vm.columns))}}}):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }